// Carica la pagina successiva solo su click: rende visibile per un momento la sentinella
// osservata da paginated-list.js e la nasconde di nuovo quando arrivano i nuovi prodotti.
document.addEventListener('click', (evento) => {
  const pulsante = evento.target.closest('.dolfi-load-more__button');
  if (!pulsante) return;
  const box = pulsante.closest('[data-dolfi-load-more]');
  const sentinella = box.querySelector('[ref="viewMoreNext"]');
  const griglia = box.parentElement.querySelector('[ref="grid"]');
  if (!sentinella || !griglia) return;
  const prima = griglia.children.length;
  pulsante.disabled = true;
  const osservatore = new MutationObserver(() => {
    if (griglia.children.length <= prima) return;
    osservatore.disconnect();
    sentinella.hidden = true;
    pulsante.disabled = false;
    const ultimaPagina = Number(griglia.dataset.lastPage);
    const paginaCaricata = Math.max(...[...griglia.querySelectorAll('[data-page]')].map((li) => Number(li.dataset.page)));
    if (paginaCaricata >= ultimaPagina) box.hidden = true;
  });
  osservatore.observe(griglia, { childList: true });
  sentinella.hidden = false;
});
